import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'lead-desafio-30-dias',
    title: 'Inscrição — Desafio de 30 dias',
    description: 'Formulário de inscrição para o seu desafio fitness. Captura contato, objetivo e nível de experiência.',
    indicatedFor: 'Personal trainers',
    stepsCount: 1,
    questionsSummary: ['Nome e contato', 'Objetivo no desafio', 'Experiência com treino', 'Aceite de regras'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Inscrição no desafio de 30 dias',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Inscreva-se no desafio',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Quero participar!',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Seu nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: 'Seu e-mail',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: 'WhatsApp',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: 'O que você espera conquistar ao final dos 30 dias?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'scale',
                        label: 'Qual é o seu nível de experiência com exercícios físicos?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Nunca treinei',
                            maxLabel: 'Treino há anos',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 6,
                        type: 'yes_no_maybe',
                        label: 'Você se compromete a seguir o desafio pelos 30 dias completos?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
